import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { vision, themessage, values, objectives } from "assets/icons/index";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const VisionAndMission = () => {
  const { t, i18n } = useTranslation();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate *******************************/}
        <QuickDonate />

        {/* quick donate popup  ************************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main title  ********************************/}
        <MainTitle title={t("Vision And Mission2")} />

        {/* vision and mission  ************************/}
        <section
          data-aos="fade-up"
          data-aos-duration="900"
          className="my-[100px] w-full px-[20px] 2xl:px-0"
        >
          {/* small talk ***********/}
          <div className="mb-[100px] mt-[50px]">
            <div
              className={`mainContainer text-second_color text-[20px] font-[600] ${
                i18n.language === "en" ? "font-Poppins" : "font-Almarai"
              }`}
            >
              {t(
                "Al-Etihad Charity Foundation relies in its strategy on a vision, mission, values , and goals through which it seeks to achieve the highest characteristics of charitable work. It is based on several rules and systems that achieve flexible administrative agility and the quality of providing high-quality educational and humanitarian services to beneficiaries."
              )}
            </div>
          </div>

          {/* description  *********/}
          <div className="mainContainer flex flex-col xl:flex-row items-center justify-center gap-[20px]">
            {/* img section */}
            <div className="hidden xl:block w-[588px] h-[921px] bg-first_color rounded-[20px]">
              <img src="images/visionandmission.png" alt="" />
            </div>

            {/* talk section  */}
            <div className="flex flex-col gap-[58px]">
              {/* vision  */}
              <div className="flex flex-col lg:flex-row items-center lg:items-start gap-[25px] xl:ml-[-73px]">
                <div>
                  <img src={vision} alt="" />
                </div>

                <div className="flex flex-col items-center lg:items-start">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[700] text-[32px] text-second_color`}
                  >
                    {t("Vision")}
                  </p>
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t(
                      "A sustainable institution that provides innovative charitable and humanitarian work to achieve quality of life."
                    )}
                  </p>
                </div>
              </div>

              {/* the message */}
              <div className="flex flex-col lg:flex-row items-center lg:items-start gap-[25px] xl:ml-[-73px]">
                <div>
                  <img src={themessage} alt="" />
                </div>

                <div className="flex flex-col items-center lg:items-start">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[700] text-[32px] text-second_color`}
                  >
                    {t("The Message")}
                  </p>
                  <p
                    className={`font-${
                      i18n.language === "en"
                        ? "Poppins lg:text-left"
                        : "Almarai lg:text-right"
                    } font-[600] text-[16px] max-w-[528px] text-center `}
                  >
                    {t(
                      "Providing innovative charitable and educational services to delight society through qualified cadres, integration with partners, and adoption of best practices."
                    )}
                  </p>
                </div>
              </div>

              {/* values */}
              <div className="flex flex-col lg:flex-row items-center lg:items-start gap-[25px] xl:ml-[-73px]">
                <div>
                  <img src={values} alt="" />
                </div>

                <div className="flex flex-col items-center lg:items-start">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[700] text-[32px] text-second_color`}
                  >
                    {t("Values")}
                  </p>
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t("• Honesty and transparency")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {" "}
                    {t("• Justice and happiness")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t("• Social responsibility")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t("• Innovation and governance")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t("• Looking forward to the future")}
                  </p>
                </div>
              </div>

              {/* objectives */}
              <div className="flex flex-col lg:flex-row items-center lg:items-start gap-[25px] xl:ml-[-73px]">
                <div>
                  <img src={objectives} alt="" />
                </div>

                <div className="flex flex-col items-center lg:items-start">
                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[700] text-[32px] text-second_color`}
                  >
                    {t("Objectives")}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t(
                      "• Providing charitable and educational services to achieve quality of life for the community"
                    )}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t(
                      "• Strengthening charitable endowments and developing resources to achieve financial sustainability"
                    )}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t(
                      "• Integration with the people of giving to provide distinguished services"
                    )}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t(
                      "• Activating communication with the community and building sustainable partnerships."
                    )}
                  </p>

                  <p
                    className={`font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[16px] max-w-[528px] text-center lg:text-left`}
                  >
                    {t(
                      "• Establishing a culture of innovation, governance and excellence in the institutional work environment"
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default VisionAndMission;
